define(["require", "exports", "tslib", "axios"], function (require, exports, tslib_1, axios_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    axios_1 = (0, tslib_1.__importDefault)(axios_1);
    var ConfigService = (function () {
        function ConfigService() {
            this.saveAxios(axios_1.default);
        }
        ConfigService.getInstance = function () {
            if (!ConfigService.instance) {
                ConfigService.instance = new ConfigService();
            }
            return ConfigService.instance;
        };
        ConfigService.prototype.getAxios = function () {
            return this.axios;
        };
        ConfigService.prototype.saveAxios = function (axios) {
            this.axios = axios.create({
                timeout: 1000 * 600
            });
        };
        return ConfigService;
    }());
    exports.default = ConfigService.getInstance();
});
//# sourceMappingURL=ServiceConfig.js.map